import { render } from "./ForgotPinSuccessPage.vue?vue&type=template&id=1342fe51"
import script from "./ForgotPinSuccessPage.vue?vue&type=script&lang=js"
export * from "./ForgotPinSuccessPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__